import React from 'react';
import cx from 'classnames';
import { NameInitials } from '../../../NameInitials';
import { DataStoreProps } from '../../common/types';
import styles from '../style.module.css';
import { Description } from './Description';
import { ShopAddress } from './ShopAddress';
import { ShopContactTablet } from './ShopContactTablet';
// import { ShopOpeningHours } from './ShopOpeningHours';
import { ShopRatings } from './ShopRatings';
import { ShopTitle } from './ShopTitle';

export const CompleteTablet = ({
  dataStore,
  handleToggleModalComment,
  handleToggleRatingModal,
  services,
  dataValue,
}: DataStoreProps) => {
  const { urlImg, logoColor, s3, phone, address, whatsapp, name, contacts } = dataStore;
  const defaultUser = !urlImg ? { backgroundColor: logoColor } : {};
  const logoBox = cx('br-100 overflow-hidden ba b--boulder', styles.logoStoreData);

  const renderLogo = () => {
    if (!urlImg) {
      return <NameInitials name={name} />;
    }
    const fullpath = `${s3}${urlImg}`;
    return <img src={fullpath} alt={name} className="h-100 w-100" />;
  };

  // const businessHours = services ? services.businessHours : null;

  return (
    <>
      <div className={styles.wrapperTablet}>
        <div className={logoBox} style={defaultUser}>
          {renderLogo()}
        </div>
        <ShopTitle>{name}</ShopTitle>
        <ShopRatings
          rate={(services && services.note) || 0}
          total={(services && services.totalRating) || 0}
          ratings={[]}
          alignStart
          className="mt16"
          handleToggleModalComment={handleToggleModalComment}
          handleToggleRatingModal={handleToggleRatingModal}
        />
      </div>
      <div className="flex row items-start pb12 w-100">
        <div className="mh12">
          <ShopContactTablet
            phone={phone}
            whatsapp={whatsapp}
            name={name}
            dataValue={dataValue}
            contacts={contacts}
          />
          <ShopAddress address={address} showH2 />
        </div>
        <div className="pl12 mt24">{/* <ShopOpeningHours businessHours={businessHours} /> */}</div>
        {services?.description && (
          <div className="mh12">
            <Description description={services?.description} />
          </div>
        )}
      </div>
    </>
  );
};
